import * as franchisesubGroupActions from './franchise-subgroup.actions';

export interface State {
    selectedId: number;
    selectedAssetCount: number;
}

export const initialState: State = {
    selectedId: null,
    selectedAssetCount: null
};

export function reducer(state = initialState, action: franchisesubGroupActions.Actions): State {
    switch (action.type) {
        case franchisesubGroupActions.SELECT: {
            let newState = state;
            if (action.payload !== state.selectedId) {
                newState = {
                    ...state,
                    selectedId: action.payload
                };
            }
            return newState;
        }

        case franchisesubGroupActions.GET_ASSET_COUNT_COMPLETE: {
            return {
                ...state,
                selectedAssetCount: action.payload
            };
        }

        default: {
            return state;
        }
    }
}

export const getSelectedId = (state: State) => state.selectedId;
export const getSelectedAssetCount = (state: State) => state.selectedAssetCount;
